import styled from 'styled-components'
import { colors } from '../../theme'

export const CardTourStyles = styled.div<{ marginTop: string }>`
  padding: 0px;
  margin-top: ${({ marginTop }) => marginTop};
  text-align: left;

  span {
    color: ${colors.grey800};
    font-weight: 400;
    font-size: 14px;
  }

  p {
    color: ${colors.grey800};
    font-weight: 600;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 16px;
  }

  strong {
    font-weight: 700;
    color: ${colors.system};
  }
`

export const CardTourWithAvatarStyles = styled.div<{ marginTop: string }>`
  padding: 0px;
  margin-top: ${({ marginTop }) => marginTop};
  text-align: center;

  span {
    color: ${colors.grey800};
    font-weight: 400;
    font-size: 14px;
  }

  p {
    color: ${colors.grey800};
    font-weight: 600;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 16px;
  }

  strong {
    font-weight: 700;
    color: ${colors.system};
  }
`

export const AvatarStyles = styled.img`
  position: absolute;
  padding: 0px;
  width: 250px;
  height: 250px;
  top: -120px;
  right: 25px;
`
